import merge from "lodash/merge";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { sendTrackingEvent } from "~/modules/actions/ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { Action } from "~/modules/actions/Action";




export interface SetAttributesOptions {
    mergeExisting?: boolean;
}




















export class SetAttributes implements Action<Promise<void>> {
    


    #attributes: Record<any, any>;

    


    #setAttributesOptions?: SetAttributesOptions;

    constructor(attributes: Record<any, any>, setAttributesOptions?: SetAttributesOptions) {
        this.#attributes = attributes;
        this.#setAttributesOptions = setAttributesOptions;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const mergeExisting = this.#setAttributesOptions?.mergeExisting || false;
        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const logger = getLogger(context)(LoggerName.Actions);

        const worker = taskRouter.worker;
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);
        logger.debug("setAttributes called with attributes ", this.#attributes);

        if (!worker) {
            const errorMsg = "setAttributes: worker is not initialized";
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const newAttributes = mergeExisting ? merge(taskRouter.worker.attributes, this.#attributes) : this.#attributes;

        try {
            await taskRouter.worker.setAttributes(newAttributes);

            sendTrackingEvent(EVENTS.SetAttributesCompleted, analytics, worker, { mergeExisting });

            return Promise.resolve();
        } catch (error) {
            const errorMsg = `setAttributes: Could not set worker attributes: ${error.message}`;
            sendTrackingEvent(EVENTS.SetAttributesCompleted, analytics, worker, { error: errorMsg, mergeExisting });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }
    }
}
